import { getCurrentTime, saveRecord, beginExecuteOrder, startEditing } from '../reducer';

export function getAvailableStates(record) {
  const hasClientRate = record.ClientRate;
  const hasProduct = record.Product && record.Product.ProductId;
  const state = getCurrentState(record);

  switch (state) {
    case 'Working':
      return [
        { key: 'cancel', display: 'Cancel', name: 'Cancelled', default: false },
        { key: 'expired', display: 'Expired', name: 'Expired', default: false },
        { key: 'execute', display: 'Execute', name: 'Executed', default: true, disabled: (!hasProduct || !hasClientRate) }
      ];
    default:
      return [
        { key: 'revert', display: 'Revert', name: 'Working', default: false }
      ];
  }
}

export function getCurrentState(order) {
  return order.ExecutionStatus;
}

export function changeState(state) {
  return (dispatch) => {
    const updateProps = {
      ExecutionStatus: state.name
    };

    if (state.name === 'Working') {
      updateProps.ExecutionDate = null;
    }

    if (state.name === 'Cancelled') {
      updateProps.CancelledAtUTC = '@CANCELLED';
    }
    const executedState = state.name === 'Executed';
    const firstStep = executedState
      ? dispatch(setExecutionDate())
      : Promise.resolve();
    return executedState ? firstStep.then(() => dispatch(startEditing())) : firstStep.then(() => dispatch(saveRecord(updateProps)));
  };
}

function setExecutionDate() {
  return (dispatch) => {
    dispatch(getCurrentTime()).then((t) => { dispatch(beginExecuteOrder(t)); });
    return Promise.resolve();
  };
}




// WEBPACK FOOTER //
// ./src/recordDetail/states/orderState.js